import {
  fetchAccessTokenFetchAds,
  watchSsoSessionState,
  fetchIpCountry,
  watchForLogOut,
} from './auth';
import { loadAdBlockDetector } from './adBlocker';
import { watchForResetCreateAd, watchAdCreated as creationSagaWatchAdCreated } from './adCreation';
import {
  watchAdFilters,
} from './adFilters';
import { watchAdReviewActions } from './adReview';
import {
  watchAdStored,
  watchAdCreated,
  watchAdRestore,
  watchClearSavedAd,
  watchLoadAd,
  checkForAdRestoreFlag,
} from './adStorage';
import { fetchTargetingItems, watchStockMusicFetch } from './targeting';
import { fetchUserInfo, fetchPartnerId } from './user';
import { fetchUserAbbaFlags } from './featureFlags';
import {
  waitToFetchPaymentInfo,
  watchFetchRecurringDetail,
  checkForHPPAdRestore,
} from './payments';
import {
  watchForRedirect,
  watchForRedirectStored,
  watchForRedirectCleared,
} from './redirect';
import {
  watchUserLoginForSentry,
  watchActionsForSentryStateLogging,
  watchForLoggableErrors,
} from './sentry';
import { watchUserGroupValidation } from './validation';
import { watchFileSelected } from './uploader';
import { fetchAdminAlert } from './adminAlert';
import { watchForFetchAudienceSize } from './audienceSizer';

export default function* root() {
  yield [
    watchForLogOut(),
    loadAdBlockDetector(),
    fetchAccessTokenFetchAds(),
    fetchUserInfo(),
    fetchPartnerId(),
    fetchTargetingItems(),
    fetchUserAbbaFlags(),
    fetchIpCountry(),
    fetchAdminAlert(),
    waitToFetchPaymentInfo(),
    watchFetchRecurringDetail(),
    watchAdStored(),
    watchAdCreated(),
    creationSagaWatchAdCreated(),
    watchAdRestore(),
    watchLoadAd(),
    watchForRedirect(),
    watchForRedirectStored(),
    watchForRedirectCleared(),
    watchForResetCreateAd(),
    // Note: checking for the ad to restore must come after watching for restore actions
    checkForAdRestoreFlag(),
    checkForHPPAdRestore(),
    watchClearSavedAd(),
    watchForLoggableErrors(),
    watchSsoSessionState(),
    watchAdReviewActions(),
    watchUserLoginForSentry(),
    watchActionsForSentryStateLogging(),
    watchUserGroupValidation(),
    watchFileSelected(),
    watchStockMusicFetch(),
    watchForFetchAudienceSize(),
    watchAdFilters(),
  ];
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/index.js